import { render, staticRenderFns } from "./v-absolute-element.vue?vue&type=template&id=9d9c94cc"
import script from "./v-absolute-element.vue?vue&type=script&lang=js"
export * from "./v-absolute-element.vue?vue&type=script&lang=js"
import style0 from "./v-absolute-element.vue?vue&type=style&index=0&id=9d9c94cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports